import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { UserProfileData } from 'types/userProfile';

const initialState: UserProfileData = {
  DefaultRecordsPerPage: null,
  DateTimeFormat: null,
  DefaultReportFormat: null,
  EmailNotification: null,
  TaggingToolBar: null,
  CurrentLandingPage: null
};

const userSettingsSlice = createSlice({
  name: 'userSettings',
  initialState,
  reducers: {
    SetSingleUserSetting(state, actions: PayloadAction<{ key: keyof UserProfileData; value: string | null }>) {
      state[actions.payload.key] = actions.payload.value;
    },
    SetAllUserSettings(state, actions: PayloadAction<UserProfileData>) {
      return { ...state, ...actions.payload };
    }
  }
});

export const { SetAllUserSettings, SetSingleUserSetting } = userSettingsSlice.actions;

export default userSettingsSlice.reducer;
